// Interaction contexts for section click-through and server-mode table scoping.
// Both default to null when no provider is mounted — sections also render in
// chat / PDF / saved-board contexts with no navigation, and must fall back to
// exactly today's non-interactive rendering there.

import { createContext, useContext } from "react";

/** Store click-through target. Provided by surfaces that can open a per-store
 *  view (the dashboard); null everywhere else. Sections use the null check to
 *  decide clickability — no provider, no buttons. */
export interface StoreNavigation {
  openStore(storeNumber: string, label?: string): void;
}

export const StoreNavigationContext = createContext<StoreNavigation | null>(null);

export function useStoreNavigation(): StoreNavigation | null {
  return useContext(StoreNavigationContext);
}

/** Server-mode scope state for a filter_table (scope.mode === "server"): the
 *  surface owns the refetch + reset semantics and feeds selection / loading /
 *  error back down. Absent provider = the scope select renders disabled. */
export interface FilterTableScope {
  selected: string | null;
  loading: boolean;
  error: string | null;
  setScope(category: string | null): void;
}

export const FilterTableScopeContext = createContext<FilterTableScope | null>(null);

export function useFilterTableScope(): FilterTableScope | null {
  return useContext(FilterTableScopeContext);
}
